import validate from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}